import axios from 'axios';
import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import LocContext from '../context/locContext';

import ClientNavbar from '../layout/ClientNavbar';

export default function ClientDashboard() {
  const { userData } = useContext(LocContext);
  const id = userData.id;

  const [userDataP, setUserDataP] = useState({});
  const [activeTab, setActiveTab] = useState('overview');
  const [data, setData] = useState([]);

  const getFundsData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/mutualfund`);
      setData(res.status === 200 ? res.data.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  const getUserData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/${id}`);
      setUserDataP(res.status === 200 ? res.data.data : {});
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getFundsData();
    getUserData();
  }, []);

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          {/* Header */}
          <div className="mb-4">
            <div className="card shadow-sm p-4">
              <h2 className="text-primary mb-1">Welcome, {userData.first_name} {userData.last_name}</h2>
              <p className="text-muted mb-0">Client Dashboard</p>
            </div>
          </div>

          {/* Tabs */}
          <ul className="nav nav-tabs mb-4">
            {['overview', 'mutualfunds', 'investments', 'profile'].map(tab => (
              <li className="nav-item" key={tab}>
                <button
                  className={`nav-link ${activeTab === tab ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === 'overview' ? 'Overview' :
                    tab === 'mutualfunds' ? 'Mutual Funds' :
                    tab === 'investments' ? 'My Investments' :
                    'Profile'}
                </button>
              </li>
            ))}
          </ul>

          {/* Tab Content */}
          {activeTab === 'overview' && (
            <div className="card shadow-sm p-4 mb-4">
              <h3 className="text-primary mb-4">Dashboard Overview</h3>
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">Mutual Fund</h5>
                    <h6 className="text-primary">₹0</h6>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">Loan</h5>
                    <h6 className="text-primary">₹0</h6>
                  </div>
                </div>
                <div className="col-md-4">
                  <Link to={'/Research-Analyst'} className="text-decoration-none">
                    <div className="card text-center bg-light p-3 h-100">
                      <h5 className="text-teal mb-1">Research Analyst</h5>
                      <h6 className="text-primary">₹0</h6>
                    </div>
                  </Link>
                </div>
              </div>

              <div className="mt-4">
                <h5 className="mb-3">Quick Actions</h5>
                <div className="d-flex gap-2 flex-wrap">
                  <button className="btn btn-primary" onClick={() => setActiveTab('mutualfunds')}>
                    Explore Mutual Funds
                  </button>
                  <button className="btn btn-primary">
                    Start New Investment
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'mutualfunds' && (
            <div className="card shadow-sm p-4 mb-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="text-primary mb-0">Available Mutual Funds</h3>
                <Link to={userData?.mutual_status === 1 ? "https://gpsfinvest.investwell.app/app/#/login" : "/Invest-application"}>
                  <button className="btn btn-primary">Invest Now</button>
                </Link>
              </div>
              <div className="row g-3">
                {data.map(fund => (
                  <div key={fund.id} className="col-md-6 col-lg-4">
                    <div className="card h-100 p-3 shadow-sm">
                      <h5 className="text-primary mb-2">{fund.name}</h5>
                      <p className="mb-1"><small className="text-muted">Category:</small> {fund.category}</p>
                      <p className="mb-1"><small className="text-muted">Risk Level:</small> {fund.risk}</p>
                      <p className="mb-1"><small className="text-muted">Expected Returns:</small> <span className="text-teal fw-bold">{fund.returns}%</span></p>
                      <p className="mb-3"><small className="text-muted">Min SIP:</small> ₹{fund.nav}</p>
                      <Link to={userDataP?.mutual_status === 1 ? "https://gpsfinvest.investwell.app/app/#/login" : "/Invest-application"}>
                        <button className="btn btn-primary w-100">Invest in this Fund</button>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'investments' && (
            <div className="card shadow-sm p-4 mb-4 text-center">
              <h3 className="text-primary mb-4">My Investments</h3>
              <p className="text-muted py-5">No investments yet. Start your investment journey today!</p>
              <div className="d-flex gap-2 justify-content-center">
                <button className="btn btn-primary" onClick={() => setActiveTab('mutualfunds')}>
                  Browse Mutual Funds
                </button>
                <Link to="/investment-verification/new" className="btn btn-primary">Start Investment Process</Link>
              </div>
            </div>
          )}

          {activeTab === 'profile' && (
            <div className="card shadow-sm p-4 mb-4">
              <h3 className="text-primary mb-4">Profile Information</h3>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label"><strong>First Name</strong></label>
                    <input type="text" value={userDataP.First_name} className="form-control" readOnly />
                  </div>
                  <div className="mb-3">
                    <label className="form-label"><strong>Last Name</strong></label>
                    <input type="text" value={userDataP.last_name} className="form-control" readOnly />
                  </div>
                  <div className="mb-3">
                    <label className="form-label"><strong>Email Address</strong></label>
                    <input type="email" value={userDataP.email} className="form-control" readOnly />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label"><strong>Contact Number</strong></label>
                    <input type="tel" value={userDataP.phone} className="form-control" readOnly />
                  </div>
                  <div className="mb-3">
                    <label className="form-label"><strong>Account Type</strong></label>
                    <input type="text" value={userDataP.type} className="form-control" readOnly />
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
   
    </>
  );
}
